import React from 'react'
import { BsChevronLeft } from 'react-icons/bs'
import SideNav from '../../Components/SideNav'
import styles from "./Styles/Requirements.module.css"
import common from "./Styles/Common.module.css"
import { useNavigate } from 'react-router-dom'

export default function Concepts() {
    const navigate = useNavigate()
  return (
    <div className={common.container}>
        <div className={common.backIcon}>
            <div onClick={()=>navigate('/dashboard/leads')}>
                <BsChevronLeft size={26} color="#0E1123" />
            </div>
            <p>Back</p>
        </div>

        <main>
            <SideNav />

            <div className={common.main}>
                concepts
            </div>
        </main>
    </div>
  )
}
